import React from 'react'

import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { MenuItem, TextField, Typography } from '@material-ui/core'

const ProfileSelect = ({ profiles = [], value = '', error, onChange }) => {
  return (
    <TextField
      label="Perfil"
      select
      color="primary"
      variant="outlined"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      error={!isEmpty(error)}
      helperText={error}
      fullWidth
    >
      {profiles.map((profile) => (
        <MenuItem key={profile.id} value={profile.id}>
          <Typography>{profile.name}</Typography>
        </MenuItem>
      ))}
    </TextField>
  )
}

ProfileSelect.propTypes = {
  profiles: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
}

export default ProfileSelect
